import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestLocationChange, fetchInitialData } from '../actions';

import Logo from '../components/Logo';

// Material UI Library
import { List, ListItem } from 'material-ui/List';
import {
  blue500,
  amber600,
  green600,
  blueGrey500,
} from 'material-ui/styles/colors';
import Avatar from 'material-ui/Avatar';

// Icons
import ActionInfo from 'material-ui/svg-icons/action/info';
import SocialGroup from 'material-ui/svg-icons/social/group';
import SocialPersonAdd from 'material-ui/svg-icons/social/person-add';
import SocialGroupAdd from 'material-ui/svg-icons/social/group-add';
import CollectionsBookmark from 'material-ui/svg-icons/image/collections-bookmark';
import ActionBook from 'material-ui/svg-icons/action/book';
import CommmunicationImportExport from 'material-ui/svg-icons/communication/import-export';

const SystemCounts = props => {
  if (props.totalCollectivesCount && props.totalInfluencersCount) {
    return `
      Collectives: ${props.totalCollectivesCount}
      Influencers: ${props.totalInfluencersCount}
    `
  }
  return '';
};

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  componentWillMount() {
    // If no auth token and not logged in, don't allow access
    if (!window.localStorage.getItem('authToken')) {
      this.props.dispatch(requestLocationChange('login'));
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchInitialData());
  }

  _changeLocation = (newLocation) => {
    this.props.dispatch(requestLocationChange(newLocation));
  };

  render() {
    const styles = {
      logo: {
        display: 'flex',
        justifyContent: 'center',
      },
      menuContainer: {
        margin: '60px auto',
        maxWidth: 600,
      }
    };

    return (
      <div>
        <div style={styles.logo}>
          <Logo width="400" height="240" scale="0.25" />
        </div>
        <List style={styles.menuContainer}>
          <ListItem
            leftAvatar={<Avatar icon={<CollectionsBookmark />} backgroundColor={amber600} />}
            primaryText="Browse Cards"
            secondaryText={SystemCounts(this.props)}
            onTouchTap={this._changeLocation.bind(this, 'search')}
          />
          <ListItem
            leftAvatar={<Avatar icon={<ActionBook />} backgroundColor={green600} />}
            primaryText="Create Card"
            initiallyOpen={false}
            primaryTogglesNestedList={true}
            nestedItems={[
              <ListItem
                key="create-card-1"
                primaryText="Individual"
                leftIcon={<SocialPersonAdd />}
                onTouchTap={this._changeLocation.bind(this, 'newInfluencer')}
              />,
              <ListItem
                key="create-card-2"
                primaryText="Collective"
                leftIcon={<SocialGroupAdd />}
                onTouchTap={this._changeLocation.bind(this, 'newCollective')}
              />,
            ]}
          />
          {this.props.currentUser.get('admin') &&
            <div>
              <ListItem
                leftAvatar={<Avatar icon={<SocialGroup />} backgroundColor={blue500} />}
                primaryText="Manage Users"
                onTouchTap={this._changeLocation.bind(this, 'userIndex')}
              />
              <ListItem
                leftAvatar={<Avatar icon={<CommmunicationImportExport />} backgroundColor={blueGrey500} />}
                primaryText="Import Data"
                onTouchTap={this._changeLocation.bind(this, 'importInfluencers')}
              />
            </div>
          }
        </List>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.get('currentUser'),
    totalCollectivesCount: state.get('collectives').get('totalSystemCount'),
    totalInfluencersCount: state.get('influencers').get('totalSystemCount'),
  };
}

export default connect(mapStateToProps)(Home);



/** WEBPACK FOOTER **
 ** ./containers/Home.js
 **/